const Marionette = require("backbone.marionette");

module.exports = Marionette.ItemView.extend({
  template: require("templates/errors/expired_signup_email_confirmation.hbs"),
});
